import getters from "@/store/modules/recruiter_ai_interviews/getters";
import actions from "@/store/modules/recruiter_ai_interviews/actions";
import mutations from "@/store/modules/recruiter_ai_interviews/mutations";
import { RecruiterAiInterviewsState } from "@/store/modules/recruiter_ai_interviews/interfaces";

export default {
  namespaced: true,
  state: (): RecruiterAiInterviewsState => ({
    invites: [],
    initialized: false
  }),
  getters,
  actions,
  mutations
};

